import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { BrandPositioning } from '../components/BrandPositioning';
import { FeaturedServices } from '../components/FeaturedServices';
import { AboutTrust } from '../components/AboutTrust';
import { AppointmentForm } from '../components/AppointmentForm';
import { TextMessagingInfo } from '../components/TextMessagingInfo';
import { SampleMessages } from '../components/SampleMessages';
import { ContactInfo } from '../components/ContactInfo';
export function HomePage() {
  return <main data-id="element-364">
      <HeroSection data-id="element-365" />
      <BrandPositioning data-id="element-366" />
      <FeaturedServices data-id="element-367" />
      <AboutTrust data-id="element-368" />
      <AppointmentForm data-id="element-369" />
      <TextMessagingInfo data-id="element-370" />
      <SampleMessages data-id="element-371" />
      <ContactInfo data-id="element-372" />
    </main>;
}